import { EmptyIcon } from '@/icons/Empty/index'
import { Empty } from 'antd'
import { useTranslation } from 'react-i18next'
import './index.css'

/**
 * 列表空状态组件
 *
 * 这是一个自定义的空状态组件，用于在列表无数据时显示友好的提示信息。
 * 支持自定义标题和描述文字
 *
 * @param title - 自定义标题文字
 * @param desc - 自定义描述文字
 * @param props - 其他传递给Empty组件的属性
 *
 * 使用场景：
 * 1. 数据列表空状态 - 表格、列表无数据时的展示
 * 2. 搜索结果空状态 - 搜索无结果时的提示
 * 3. 筛选结果空状态 - 筛选条件无匹配结果时
 * 4. 收藏夹空状态 - 收藏列表为空时的提示
 * 5. 历史记录空状态 - 历史记录为空时的展示
 * 6. 消息列表空状态 - 消息列表为空时的提示
 * 7. 文件列表空状态 - 文件列表为空时的展示
 * 8. 任务列表空状态 - 任务列表为空时的提示
 *
 * 使用示例：
 * ```tsx
 * // 基础用法
 * <ListEmpty />
 *
 * // 自定义标题和描述
 * <ListEmpty
 *   title="暂无数据"
 *   desc="请尝试其他搜索条件"
 * />
 *
 * // 在表格中使用
 * <Table
 *   dataSource={[]}
 *   locale={{ emptyText: <ListEmpty /> }}
 * />
 *
 * // 在列表中使用
 * {data.length === 0 ? (
 *   <ListEmpty
 *     title="暂无内容"
 *     desc="快去添加一些内容吧"
 *   />
 * ) : (
 *   <List data={data} />
 * )}
 * ```
 */
const ListEmpty = (props: any) => {
  const { t } = useTranslation()
  return (
    <Empty
      image={<EmptyIcon />}
      description={
        <div className="lenovo-list-empty-content">
          <span className="lenovo-list-empty-title">{props.title ? props.title : t('listEmptyTitle')}</span>
          <span className="lenovo-list-empty-text">{props.desc ? props.desc : t('listEmptyDes')}</span>
        </div>
      }
      className="lenovo-list-empty"
      {...props}
    />
  )
}

export default ListEmpty
